import { DetailsState } from 'src/types/redux';
import {
  FETCH_DETAILS_FAILURE,
  FETCH_DETAILS_REQUEST,
  FETCH_DETAILS_SUCCESS,
  DetailsActionType,
} from '../types/detailsType';

const initialState: DetailsState = {
  error: '',
  loading: false,
  detailsData: [],
};

export const detailsReducer = (
  state = initialState,
  action: DetailsActionType
): DetailsState => {
  switch (action?.type) {
    case FETCH_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        detailsData: action?.payload,
      };
    case FETCH_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
